<button mat-icon-button
        [matMenuTriggerFor]="themeMenu"
        class="theme-switcher__btn"
        aria-label="Switch brand theme">
  <mat-icon aria-hidden="true">format_color_fill</mat-icon>
</button>

<mat-menu #themeMenu="matMenu">
  @for (theme of themeService.availableThemes(); track theme) {
    <button mat-menu-item (click)="selectTheme(theme)">
      <mat-icon>
        {{ siteStore.theme() === theme ? 'radio_button_checked' : 'radio_button_unchecked' }}
      </mat-icon>
      <span>{{ themeLabels[theme] }}</span>
    </button>
  }
</mat-menu>
